import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const operatingStatesRoutes: Array<RouteObject> = [
  {
    id: "operating-states",
    path: "*",
    lazy: async () => convertRouteModule(await import("./operating-states")),
    children: [
      { index: true, lazy: async () => convertRouteModule(await import("./application")) },
    ],
  },
];
